import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0px;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
  }

  body {
    background: #E5E5E5 no-repeat;
  }

  #root {
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  body, input, button {
    font-family: 'Lato', sans-serif;
  }

  h1, h2, h3, h4, h5, h6, span, p, strong {
    font-family: 'Lato', sans-serif;
    font-weight: 450;
  }

  button: {
    cursor: pointer;
  }
`;
